"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DefaultTheme", {
    enumerable: true,
    get: function() {
        return DefaultTheme;
    }
});
const _fonts = require("./fonts");
const DefaultTheme = {
    dark: false,
    colors: {
        primary: 'rgb(0, 122, 255)',
        background: 'rgb(242, 242, 242)',
        card: 'rgb(255, 255, 255)',
        text: 'rgb(28, 28, 30)',
        border: 'rgb(216, 216, 216)',
        notification: 'rgb(255, 59, 48)'
    },
    fonts: _fonts.fonts
};

//# sourceMappingURL=DefaultTheme.js.map
